import {Component, Input, OnInit} from "@angular/core";
import * as fromStore from '../store';
import {Store} from "@ngrx/store";
import {DialogComponent} from "../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../ng2-bootstrap-modal/dialog.service";
import {Config} from "../config/config";
import {IActivity} from "../activities/activity";
import {Observable} from "rxjs";

@Component({
    selector: 'db-optimizer-loading',
    templateUrl: './optimizer-loading.component.html',
    styleUrls: ['./optimizer-loading.component.scss'],
    standalone: false
})
export class OptimizerLoadingComponent extends DialogComponent<null, boolean> implements OnInit {

  public ongoingOptimizerActivity$: Observable<IActivity>;
  @Input() websiteId: number;

  constructor(
    private _dialogService: DialogService,
    private _store: Store<fromStore.DbStoreState>
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.ongoingOptimizerActivity$ = this._store.select(fromStore.getOptimizerOngoingActivity(this.websiteId, Config.optimizerPluginSlug));
    this.ongoingOptimizerActivity$
      .subscribe((data): void => {
        if (data) {
          if (data.status === 'done' || data.status === 'failed') {
            this.close();
          }
        }
      });
  }

}
